import { renderAlert } from "../../CommonComponents/Alert/Alert.jsx";
import { lazy } from "react";

// export const fetchTicketsByJQL=(sourceDetails,params)=>async(dispatch)=>{
//     let res=await POST('/source/getRecordList',{sourceDetails,params})
//     let issueObj={};
//     if(res && res.data){
//         res.data.forEach((issue)=>{
//             issueObj[issue.key] = issue
//           })
//         return {"issues": res.data, "issueObj": issueObj}
//     }
//     else return {issues:[]}
// }

// export const fetchSourceFields=(sourceDetails)=>async(dispatch)=>{
//     const res = await POST('/source/getColumns', sourceDetails);
//     if(res && res.data) return {'fields': res.data}
//     else return []
// }

  export const fetchSourceFields=(sourceDetails)=>async(dispatch)=>{
    try{ 
    const apolloGraphQlClient=(await import('../../GraphQL/DataAccessGraphQLClient.js')).default
    const {GET_COLUMNS} = await import("../../GraphQL/Queries.js")
    const variables = { sourceDetails };
    const { data } = await apolloGraphQlClient.query({ query: GET_COLUMNS, variables });
        if(data && data.getColumns) return {'fields': data.getColumns}
    else return []
  }
  catch(error){
    console.log( "Error in fetching field ",error);
  }
  }

export const fetchTicketsByJQL = (sourceDetails, params) => async (dispatch) => {
    const apolloGraphQlClient=(await import('../../GraphQL/DataAccessGraphQLClient.js')).default
    const {GET_RECORDS} = await import("../../GraphQL/Queries.js")
    const variables = { sourceDetails, params };
    const { data } = await apolloGraphQlClient.query({ query: GET_RECORDS, variables });
    if (data && data.getRecordList) {
      const { issues ,issueObj} = data.getRecordList;

      return { issues, issueObj };
    } else {
      return { issues: [] };
    }
};

export const changeRecord=async({id,value,field,columns,columnId})=>{
  const apolloGraphQlClient=(await import('../../GraphQL/DataAccessGraphQLClient.js')).default
  const {CHANGE_RECORD_MUTATION} = await import("../../GraphQL/Queries.js")
  let columnID=columnId.endsWith("_es")?columnId.slice(0,-3):columnId
  let Column=columns.filter((column)=>column.field===columnID)
  let fieldFormat=Column[0].columnFormat
  let sourceDetails = {type: 'JIRA'};
  let variables={sourceDetails,params:{id,meta:{value,field,fieldFormat}}}
  const {data:temp,errors}=await apolloGraphQlClient.mutate({mutation:CHANGE_RECORD_MUTATION, variables})

  if(temp.changeRecord=='Request failed'){
    renderAlert('The given field cannot be edited or your value is invalid', 'error')
  }
}